<div fxLayout="row" [hidden]="loading" fxLayoutGap="24px">
  <!--Header and search field-->
  <div fxLayout="column" style="height: 100%">
    <div fxLayout="row">
      <h2>Training Load Analysis</h2>
    </div>

    <div fxLayout="row">
      <mat-form-field>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" placeholder="Search" [formControl]="search" />
      </mat-form-field>

    </div>

    <!--selection list-->
    <mat-tab-group id="explore-tab-group" fxFlex="30">
      <!-- marines tab-->
      <mat-tab label="Marines">
        <ng-template matTabContent>
          <cdk-virtual-scroll-viewport itemSize="50" style="height: 90vh;">
            <mat-action-list>
              <mat-list-item *cdkVirtualFor="let marine of marines | filterUsers: search.value"
                (click)="selectMarine(marine)"
                [ngClass]="{ selected: selectedMarine && selectedMarine.uuid === marine.uuid }">
                <div fxLayout="column">
                  <div matLine>
                    <b>{{ marine.firstName + ' ' + marine.lastName }} </b>
                  </div>
                </div>
              </mat-list-item>
            </mat-action-list>
          </cdk-virtual-scroll-viewport>
        </ng-template>
      </mat-tab>
      <!--plans tab-->
      <mat-tab label="Plans">
        <ng-template matTabContent>

          <cdk-virtual-scroll-viewport itemSize="50" style="height: 82vh;">

            <mat-action-list>
              <mat-list-item *cdkVirtualFor="let plan of plans | filterPlans: search.value" (click)="selectPlan(plan)"
                [ngClass]="{ selected: selectedPlan === plan }">
                <div fxLayout="column">
                  <div matLine>
                    <b>{{ plan.name }} </b>
                  </div>
                </div>
              </mat-list-item>
            </mat-action-list>
          </cdk-virtual-scroll-viewport>
        </ng-template>

      </mat-tab>
      <!--groups tab-->
      <mat-tab label="Groups">
        <ng-template matTabContent>
          <cdk-virtual-scroll-viewport itemSize="50" style="height: 82vh;">
            <mat-action-list>
              <mat-list-item *cdkVirtualFor="let group of groups | filterGroups: search.value"
                (click)="selectGroup(group)" [ngClass]="{ selected: selectedGroup === group }">
                <div fxLayout="column">
                  <div matLine>
                    <b>{{ group.name }}</b>
                  </div>
                  <div [ngPlural]="group.members.length" matLine>
                    <ng-template ngPluralCase="=1">{{ group.members.length }} member</ng-template>
                    <ng-template ngPluralCase="other">{{ group.members.length }} members</ng-template>
                  </div>
                </div>
              </mat-list-item>
            </mat-action-list>
          </cdk-virtual-scroll-viewport>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  <!--main screen-->
  <div fxFlex="70" fxLayout="column" style="height: 100%">
    <mat-spinner *ngIf="loading" diameter="48" mode="indeterminate" style="margin: 2rem auto;"></mat-spinner>

    <!--marines table-->
    <ng-container *ngIf="tabState === 0 && !loading">
      <!--User summary-->
      <div fxFlex="20" *ngIf="selectedMarine" class="user-summary">
        <div fxFlex="40" class="user-summary-item" fxLayout="column">
          <h1 color="primary">{{selectedMarine.rank + ' ' + selectedMarine.firstName + ' ' + selectedMarine.lastName}}
          </h1>
        </div>
      </div>

      <div *ngIf="dataSourceIndividuals.data" fxLayout="row">

        <button mat-icon-button (click)="prevWeekRange()" [disabled]="firstWeekRangeSelected">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <training-load-chart fxFlex="85" [height]="'400px'" [seriesLabels]="seriesLabels" [barSeries]="barSeries"
          [lineSeries]="lineSeries" [barLabel]="barLabel" [lineLabel]="lineLabel" [xLabel]="'Week Start'" [yLabel]="'Training Load'">
        </training-load-chart>
        <button mat-icon-button (click)="nextWeekRange()" [disabled]="lastWeekRangeSelected">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>

      <table fxFlex="80" mat-table [dataSource]="dataSourceIndividuals">

        <!--Date column-->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let workout"> {{workout.date | date}} </td>
        </ng-container>

        <!--Name column-->
        <ng-container matColumnDef="workoutName">
          <th mat-header-cell *matHeaderCellDef> Workout Name </th>
          <td mat-cell *matCellDef="let workout"> {{workout.workoutName }} </td>
        </ng-container>

        <!--Group column-->
        <ng-container matColumnDef="groupName">
          <th mat-header-cell *matHeaderCellDef> Group </th>
          <td mat-cell *matCellDef="let workout"> {{workout.groupName || 'Not found'}} </td>
        </ng-container>

        <!-- Completed column -->
        <ng-container matColumnDef="isComplete">
          <th mat-header-cell *matHeaderCellDef> Completed </th>
          <td mat-cell *matCellDef="let workout">
            <mat-icon *ngIf="workout.isComplete" color="primary">check_circle</mat-icon>
          </td>
        </ng-container>

        <!-- Est TL column -->
        <ng-container matColumnDef="estTrainingLoad">
          <th mat-header-cell *matHeaderCellDef> Target TL</th>
          <td mat-cell *matCellDef="let workout">{{workout.estTrainingLoad | number:'1.0-1'}}</td>
        </ng-container>

        <!-- Actual TL column -->
        <ng-container matColumnDef="actualTrainingLoad">
          <th mat-header-cell *matHeaderCellDef> Actual TL</th>
          <td mat-cell *matCellDef="let workout">{{workout.actualTrainingLoad | number:'1.0-1'}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="marineColumns"></tr>
        <tr mat-row *matRowDef="let rowData; columns: marineColumns"></tr>
      </table>

    </ng-container>

    <!--Plans table-->
    <ng-container *ngIf="tabState === 1 && !loading">
      <div fxFlex="20" *ngIf="selectedPlan" class="user-summary">
        <div class="user-summary-item" fxLayout="column">
          <h1 color="primary">{{selectedPlan.name}}
          </h1>
        </div>
      </div>
      <div *ngIf="dataSourcePlans.data" fxLayout="row">

        <button mat-icon-button (click)="prevWeekRange()" [disabled]="firstWeekRangeSelected">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <training-load-chart fxFlex="85" [height]="'400px'" [seriesLabels]="seriesLabels" [barSeries]="barSeries"
          [lineSeries]="lineSeries" [barLabel]="barLabel" [lineLabel]="lineLabel">
        </training-load-chart>
        <button mat-icon-button (click)="nextWeekRange()" [disabled]="lastWeekRangeSelected">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>

      <table fxFlex="80" mat-table [dataSource]="dataSourcePlans">
        <!--Date column-->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let day"> {{day.date | date}} </td>
        </ng-container>

        <!--Phase column-->
        <ng-container matColumnDef="phase">
          <th mat-header-cell *matHeaderCellDef> Phase </th>
          <td mat-cell *matCellDef="let day"> {{day.phase}} </td>
        </ng-container>

        <!--Workout Name column-->
        <ng-container matColumnDef="playcardName">
          <th mat-header-cell *matHeaderCellDef> Workout Name </th>
          <td mat-cell *matCellDef="let day"> {{day.workoutName}} </td>
        </ng-container>

        <!--Actual Training Load column-->
        <ng-container matColumnDef="actualTrainingLoad">
          <th mat-header-cell *matHeaderCellDef> Actual Mean TL </th>
          <td mat-cell *matCellDef="let day"> {{day.meanActualTrainingLoad |
            number:'1.0-1'}}</td>
        </ng-container>

        <!--Est Training Load column-->
        <ng-container matColumnDef="estTrainingLoad">
          <th mat-header-cell *matHeaderCellDef> Target Mean TL </th>
          <td mat-cell *matCellDef="let day"> {{day.meanEstTrainingLoad
            | number:'1.0-1'}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="planColumns"></tr>
        <tr mat-row *matRowDef="let rowData; columns: planColumns"></tr>
      </table>

    </ng-container>

    <!--Groups table-->

    <ng-container *ngIf="tabState === 2 && !loading">
      <div fxFlex="20" *ngIf="selectedGroup" class="user-summary">
        <div class="user-summary-item" fxLayout="column">
          <h1 color="primary">{{selectedGroup.name}}
          </h1>
        </div>
      </div>
      <div *ngIf="dataSourceGroups.data" fxLayout="row">
        <button mat-icon-button (click)="prevWeekRange()" [disabled]="firstWeekRangeSelected">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <training-load-chart fxFlex="85" [height]="'400px'" [seriesLabels]="seriesLabels" [lineSeries]="lineSeries"
          [barSeries]="barSeries" [lineLabel]="lineLabel" [barLabel]="barLabel">
        </training-load-chart>
        <button mat-icon-button (click)="nextWeekRange()" [disabled]="lastWeekRangeSelected">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
      <table fxFlex="80" mat-table [dataSource]="dataSourceGroups">

        <!--Date column-->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let plan"> {{plan.date | date}} </td>
        </ng-container>

        <!--Plan Name column-->
        <ng-container matColumnDef="planName">
          <th mat-header-cell *matHeaderCellDef> Plan Name </th>
          <td mat-cell *matCellDef="let plan"> {{plan.planName}} </td>
        </ng-container>

        <!--Workout Name column-->
        <ng-container matColumnDef="playcardName">
          <th mat-header-cell *matHeaderCellDef> Workout Name </th>
          <td mat-cell *matCellDef="let plan"> {{plan.workoutName}} </td>
        </ng-container>
        <!--Avg Training Load column-->
        <ng-container matColumnDef="actualTrainingLoad">
          <th mat-header-cell *matHeaderCellDef> Actual Mean TL </th>
          <td mat-cell *matCellDef="let plan"> {{plan.meanActualTrainingLoad |
            number:'1.0-1'}} </td>
        </ng-container>

        <!--Est Training Load column-->
        <ng-container matColumnDef="estTrainingLoad">
          <th mat-header-cell *matHeaderCellDef> Target Mean TL </th>
          <td mat-cell *matCellDef="let plan"> {{plan.meanEstTrainingLoad | number:'1.0-1'}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="groupColumns"></tr>
        <tr mat-row *matRowDef="let rowData; columns: groupColumns"></tr>
      </table>

    </ng-container>
    <mat-spinner *ngIf="loadingTrainingLoads && !loading" diameter="48" mode="indeterminate" style="margin: 2rem auto;">
    </mat-spinner>

    <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
    </mat-paginator>
  </div>
</div>
<ngx-guided-tour></ngx-guided-tour>